var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-hero',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle},scopedSlots:_vm._u([(_vm.$slots.default)?{key:"actions",fn:function(){return [_vm._t("default")]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }